import { IS_AUTO_TEST_HIDE } from 'reactApp/appHelpers/configHelpers';
import { isTouchSearchEnabled } from 'reactApp/appHelpers/featuresHelpers';
import { storeHelper } from 'reactApp/modules/promo/promo.helpers';
import { addPromoToShowQueue, promoShown, removePromo } from 'reactApp/modules/promo/promo.module';
import { PromoSelectors } from 'reactApp/modules/promo/promo.selectors';
import { EPromoType } from 'reactApp/modules/promo/promo.types';
import { store } from 'reactApp/store';
import { renderMobileSearchNotification } from 'reactApp/ui/Mobile/SearchNotification/helpers/SearchNotificatin.helpers';
import { useFacesFilterScreen } from 'reactApp/ui/Mobile/SplashScreen/hooks/useFacesFilterScreen';
import { call, put } from 'redux-saga/effects';
import { select } from 'typed-redux-saga';

const SEARCH_BANNER_ID = 'search-tooltip-touch-notification';

export function* initMobileSearchBanner() {
    if (IS_AUTO_TEST_HIDE || !isTouchSearchEnabled || storeHelper.getValue(SEARCH_BANNER_ID)) {
        return;
    }

    yield put(
        addPromoToShowQueue({
            type: EPromoType.mobileSearchBanner,
            promoId: SEARCH_BANNER_ID,
            onShow: () => {
                store.dispatch(promoShown(EPromoType.mobileSearchBanner));
                storeHelper.markAsShown(SEARCH_BANNER_ID);
            },
            onClose: () => {
                store.dispatch(removePromo(EPromoType.mobileSearchBanner));
            },
        })
    );
}

export function* showMobileSearchBanner() {
    const mobileSearchBanner = yield* select(PromoSelectors.getPromo(EPromoType.mobileSearchBanner));

    if (!mobileSearchBanner) {
        return;
    }

    mobileSearchBanner.onShow();
    yield call(renderMobileSearchNotification, { contentHook: useFacesFilterScreen }, mobileSearchBanner.onClose());
}
